import { tabs } from '../../constants';
import {
    favoritesEditFolderRule,
    favoritesRearrangeItemsRule,
    discoveryFeedRule,
} from './favoritesCalloutRules';

const newDiscoveryFeedConfig = {
    name: 'newDiscoveryFeed',
    priority: 410,
    rule: discoveryFeedRule,
    action: () => dispatch =>
        dispatch({
            type: 'SHOW_DISCOVERY_FEED_CALLOUT',
        }),
};

const editFolderConfig = {
    name: 'favoritesEditFolder',
    priority: 400,
    rule: favoritesEditFolderRule,
    action: () => dispatch =>
        dispatch({
            type: 'SHOW_FAVORITES_FOLDER_CALLOUT',
        }),
};

const rearrangeItemsConfig = {
    name: 'favoritesRearrangeItems',
    priority: 405,
    rule: favoritesRearrangeItemsRule,
    action: () => dispatch =>
        dispatch({
            type: 'SHOW_FAVORITES_REARRANGE_ITEMS_CALLOUT',
        }),
};

export const favoritesCallouts = {
    [tabs.DISCOVER]: [newDiscoveryFeedConfig],
    [tabs.FOLDER]: [editFolderConfig, rearrangeItemsConfig],
    [tabs.FOLDERS]: [editFolderConfig, rearrangeItemsConfig],
    [tabs.FOLLOWING]: [editFolderConfig, rearrangeItemsConfig],
    [tabs.ITEMS]: [editFolderConfig, rearrangeItemsConfig],
    [tabs.PROJECT]: [editFolderConfig, rearrangeItemsConfig],
    [tabs.PROJECTS]: [editFolderConfig, rearrangeItemsConfig],
};
